module.exports = __webpack_public_path__ + "static/media/reo.caebc3c2.png";